<template>
  <div class="w-full pt-5 pb-5">
    <template>
      <div class="flex items-center">
        <div class="border-r border-romanSilver h-6 flex">
          <BackButton
            label="Back"
            @onClick="$router.back()"
            variant="secondary"
            class="ml-2"
          />
        </div>
        <h1 class="text-xl text-left font-extrabold mx-4">
          Appraisal Scorecard
        </h1>
        <Breadcrumb :items="breadcrumbs" />
      </div>
    </template>
    <template v-if="isLoading">
      <div style="height: 100%" class="mt-20">
        <loader size="xxs" :loader-image="false" />
      </div>
    </template>
    <template v-else>
      <template>
        <div class="p-5 flex flex-col shadow m-5 rounded-md gap-4">
          <template>
            <div class="flex justify-between items-center">
              <span
                class="font-bold text-lg leading-5 tracking-normal capitalize text-darkPurple"
              >
                {{ agreementData.title }}
              </span>
            </div>
          </template>
          <template>
            <div
              class="border border-dashed bg-white border-romanSilver rounded-md gap-4 p-3 mt-4"
            >
              <div
                class="flex justify-between items-center w-full gap-4 pb-2 cursor-pointer"
                @click="handleShowDetails"
              >
                <span
                  class="font-black text-xs leading-5 uppercase tracking-wider text-romanSilver"
                >
                  Performance Details
                </span>
                <span
                  class="w-9/12 border-t border-solid border-romanSilver h-0"
                />
                <Icon
                  :icon-name="showDetails ? 'chevronDown' : 'chevronRight'"
                  class-name="text-darkPurple mx-auto self-center"
                  size="xms"
                />
              </div>
              <div
                class="flex flex-col gap-2"
                :class="{ hidden: !showDetails }"
              >
                <div class="flex p-3 shadow rounded-md gap-2">
                  <Icon
                    size="s"
                    icon-name="doc-cycle"
                    class-name="text-romanSilver self-start pt-1"
                  />
                  <div class="flex flex-col">
                    <span
                      class="font-black leading-5 text-xs tracking-wide text-darkPurple uppercase"
                    >
                      {{ agreementData.cycle }}
                    </span>
                    <span
                      class="font-bold text-sm leading-6 tracking-wide text-jet uppercase"
                    >
                      {{ agreementData.description }}
                    </span>
                  </div>
                </div>
                <div class="flex flex-wrap">
                  <div
                    class="flex p-3 shadow rounded-md gap-2 w-2/5 mr-2 mt-2 flex-grow"
                  >
                    <Icon
                      size="xs"
                      icon-name="calendar"
                      class-name="text-romanSilver self-start pt-1"
                    />
                    <div class="flex flex-col">
                      <span
                        class="font-black leading-5 text-xs tracking-wide text-carrotOrange uppercase"
                      >
                        Period
                      </span>
                      <span
                        class="font-bold text-sm leading-6 tracking-wide text-jet uppercase"
                      >
                        {{
                          $DATEFORMAT(
                            new Date(agreementData.period.start),
                            "MMMM dd, yyyy"
                          )
                        }}
                        -
                        {{
                          $DATEFORMAT(
                            new Date(agreementData.period.end),
                            "MMMM dd, yyyy"
                          )
                        }}
                      </span>
                    </div>
                  </div>
                  <div
                    class="flex p-3 shadow rounded-md gap-2 w-2/5 mt-2 flex-grow"
                    v-for="(cycle, index) in agreementCycles"
                    :key="index"
                    :class="cycle.active ? '' : 'opacity-40'"
                  >
                    <Icon
                      class-name="text-romanSilver self-start pt-1"
                      size="xs"
                      icon-name="reviewicon"
                    />
                    <div class="flex flex-col">
                      <span
                        class="font-black leading-5 text-xs tracking-wide text-blueCrayola uppercase"
                      >
                        {{ cycle.name }}
                      </span>
                      <span
                        class="font-bold text-sm leading-6 flex tracking-wide text-jet uppercase"
                      >
                        {{
                          $DATEFORMAT(new Date(cycle.start), "MMMM dd, yyyy")
                        }}
                        -
                        {{ $DATEFORMAT(new Date(cycle.end), "MMMM dd, yyyy") }}
                        <span v-if="extendedCycle">
                          <span
                            class="ml-4 flex"
                            v-if="extendedCycle.appraisalCycleId === cycle.id"
                          >
                            <p
                              class="text-sm uppercase text-mediumSeaGreen italic"
                              style="margin-top: 0.15rem"
                            >
                              Extended
                            </p>
                            <Icon
                              class="ml-3"
                              icon-name="icon-info"
                              size="xs"
                              style="margin-top: -0.15rem"
                            />
                          </span>
                        </span>
                        <span
                          class="font-bold ml-6 text-xs leading-6 flex tracking-wide text-mediumSeaGreen uppercase flex cursor-pointer"
                          @click="viewCycle(cycle.id)"
                        >
                          View
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </template>
      <template>
        <div class="w-full px-5">
          <div class="w-full">
            <Card class="p-5 pt-0">
              <CardFooter
                reloadcard
                showcalendar
                @searchResult="handleSearch($event)"
              >
                <template v-slot:leftItems>
                  <!--- <Select
                  placeholder="Direct Reports"
                  :options="['Direct Reports', 'All My Reports']"
                /> -->
                </template>
              </CardFooter>
            </Card>
          </div>
          <div style="height: 100%" v-if="isLoading">
            <Loader size="xxs" :loader-image="false" />
          </div>
          <div v-else>
            <Table
              :headers="AppHeader"
              :items="items"
              :loading="loadingTable"
              aria-label="advance Table"
              class="w-full"
              :has-checkbox="false"
              :has-number="true"
              :pagination-list="metaData"
              @page="handlePage($event)"
              @itemsPerPage="handleItemsPerPage($event)"
              page-sync
            >
              <template v-slot:item="{ item }">
                <div
                  v-if="item.photo"
                  class="flex justify-start items-center gap-5"
                >
                  <div class="bg-mediumSeaGreen w-2 h-2 rounded-full" />
                  <div>
                    <img
                      class="mr-3"
                      :src="item.data.photo"
                      v-if="item.data.photo"
                      alt="user photo"
                      style="height: 30px; width: 30px; border-radius: 5px"
                    />
                    <div
                      style="height: 30px; width: 30px; border-radius: 5px"
                      class="text-blueCrayola mr-3 flex justify-center border text-center font-semibold pt-1"
                      v-else
                    >
                      {{ $getInitials(`${item.data.appraisee}`) }}
                    </div>
                  </div>
                </div>

                <div v-if="item.appraisee">
                  <span
                    class="text-center text-sm leading-6 font-normal text-darkPurple"
                  >
                    {{ item.data.appraisee }}
                  </span>
                </div>
                <div v-if="item.designation">
                  <span
                    class="text-center text-sm leading-6 font-normal text-darkPurple"
                  >
                    {{ item.data.designation }}
                  </span>
                </div>
                <div v-if="item.jobLevel">
                  <span
                    class="text-center text-sm leading-6 font-normal text-darkPurple"
                  >
                    {{ item.data.jobLevel }}
                  </span>
                </div>
                <div v-if="item.functions">
                  <span
                    class="text-center text-sm leading-6 font-normal text-darkPurple"
                  >
                    {{ item.data.functions }}
                  </span>
                </div>
                <div v-if="item.appraisalScore">
                  <span
                    class="text-center text-sm leading-6 font-normal text-darkPurple"
                  >
                    {{ item.data.appraisalScore }}
                  </span>
                </div>
                <div v-if="item.appraisalDate">
                  <span
                    class="font-normal text-sm leading-6 tracking-wide text-jet capitalize"
                  >
                    {{
                      item.data.appraisalDate
                        ? $DATEFORMAT(
                            new Date(item.data.appraisalDate),
                            "MMMM dd, yyyy"
                          )
                        : "---"
                    }}
                  </span>
                </div>
              </template>
            </Table>
            <template>
              <div class="flex justify-end gap-2 py-5 uppercase">
                <div
                  class="w-60 flex flex-col justify-center items-center border border-romanSilver rounded-md py-2"
                >
                  <span
                    class="font-semibold text-base leading-5 text-darkPurple"
                    >{{ averageScore }}</span
                  >
                  <span class="font-semibold text-xs leading-5text-romainSilver"
                    >average score</span
                  >
                </div>
                <div
                  class="w-60 flex flex-col justify-center items-center border border-romanSilver rounded-md py-2"
                >
                  <span
                    class="font-semibold text-base leading-5 text-darkPurple"
                    >{{ myScore }}</span
                  >
                  <span class="font-semibold text-xs leading-5text-romainSilver"
                    >my score</span
                  >
                </div>
              </div>
            </template>
          </div>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import BackButton from "@scelloo/cloudenly-ui/src/components/back-button";
import Breadcrumb from "@scelloo/cloudenly-ui/src/components/bread-crumb";
import Table from "@scelloo/cloudenly-ui/src/components/table";
// import Select from "@scelloo/cloudenly-ui/src/components/select";
import Card from "@scelloo/cloudenly-ui/src/components/card";
import CardFooter from "@/components/CardFooter";
import paramsMixin from "@/utilities/paramsMixin";
import timeFormatMixin from "@/utilities/timeFormatMixin";

export default {
  name: "OrganisationScorecard",
  mixins: [paramsMixin, timeFormatMixin],
  components: {
    BackButton,
    Breadcrumb,
    Table,
    // Select,
    Card,
    CardFooter,
  },
  data() {
    return {
      isLoading: false,
      loadingTable: true,
      showDetails: true,
      myScore: "",
      breadcrumbs: [
        {
          disabled: false,
          text: "Performance",
          href: "Performance",
          id: "Performance",
        },
        {
          disabled: false,
          text: "Performance Appraisal",
          href: "Performance Appraisal",
          id: "PerformanceAppraisal",
        },
        {
          disabled: false,
          text: "Appraisal Scorecard",
          href: "appraisal-scorecard",
          id: "AppraisalScorecard",
        },
      ],
      AppHeader: [
        { title: "", value: "photo", width: "6" },
        { title: "Name", value: "appraisee" },
        { title: "Designation", value: "designation" },
        { title: "Job Level", value: "jobLevel" },
        { title: "Function", value: "functions" },
        { title: "Appraisal Score", value: "appraisalScore" },
        { title: "Appraisal Date", value: "appraisalDate" },
      ],
      items: [],
      agreementData: {
        title: null,
        cycle: null,
        description: null,
        period: { start: null, end: null },
      },
      templatesArr: [],
      cyclesArr: [],
      agreementCycles: [],
      averageScore: "",
      extendedCycle: {},
      activeCycle: "",
      searchQuery: "",
      metaData: {},
      itemsPerPage: null,
      numberOfPage: null,
    };
  },
  methods: {
    handleItemsPerPage(itemNo) {
      this.itemsPerPage = itemNo;
      this.queryUpdate();
    },

    handlePage(pageNumber) {
      this.numberOfPage = pageNumber;
      this.queryUpdate();
    },

    queryUpdate() {
      this.loadingTable = true;
      const search = this.searchQuery ? `${this.searchQuery}` : "";
      const pageNumber = this.numberOfPage
        ? `&page=${this.numberOfPage}`
        : `&page=${this.metaData.page}`;
      const itemPage = this.itemsPerPage ? `&perPage=${this.itemsPerPage}` : "";
      this.getScoreCard(`?${pageNumber}${itemPage}${search}`);
    },

    handleSearch(value) {
      this.searchQuery = `&search=${value}`;
      this.loadingTable = true;
      this.getScoreCard(this.searchQuery);
    },

    handleShowDetails() {
      this.showDetails = !this.showDetails;
    },

    getTemplate() {
      const currentYear = this.$route.params.year;

      this.$_getPerfomanceTemplate("").then((response) => {
        const templatesArr = response.data.PerformanceTemplate;

        templatesArr.filter((template) => {
        if (template.year === Number(currentYear)) {
          this.agreementData.title = template.title;
          this.agreementData.cycle = template.title;
          this.agreementData.description = template.agreement_description;
          this.agreementData.period.start = this.setDates(
            template.appraisal_cycle.agreement_start
          ).toISOString();
          this.agreementData.period.end = this.setDates(
            template.appraisal_cycle.agreement_end
          ).toISOString();
        }
        return {};
      });

      });
    },


    getAppraisalCycle() {
      const today = new Date();

      this.$_getAppraisalCycle(this.appraisalQuery()).then((response) => {
        const appraisal = response.data.AppraisalCycle;
        const { extension } = response.data;

        this.extendedCycle = extension;

        this.agreementData.description = appraisal[0].description;

        if (appraisal[0].cycles.length > 0) {
          const appraisalCycle = appraisal[0].cycles.sort(
            (a, b) =>
              this.setDates(a.appraisal_starts) -
              this.setDates(b.appraisal_starts)
          );

          appraisalCycle.forEach((cycle) => {
            this.cyclesArr.push(cycle.id);

            const cycleStartDate = new Date(
              this.formatDateTime(cycle.appraisal_starts)
            );

            const cycleEndDate = new Date(
              this.formatDateTime(cycle.appraisal_ends)
            );

            cycleEndDate.setDate(cycleEndDate.getDate() + 1);

            this.agreementCycles.push({
              name: cycle.name,
              start: this.formatDateTime(cycle.appraisal_starts),
              end: this.formatDateTime(cycle.appraisal_ends),
              active: today >= cycleStartDate && today <= cycleEndDate,
              id: cycle.id,
            });

            const cycleData = this.agreementCycles.find(
              (cycles) => cycles.active
            );

            if (cycleData) {
              this.activeCycle = cycleData.id;
            } else {
              this.activeCycle = this.agreementCycles[0].id;
            }
          });
        }
        this.getScoreCard('');
      });
    },


    getScoreCard(params) {
      this.items = [];
      const query = `?cycleId=${this.activeCycle}${params || ''}`;
      this.$_getAppraisalScoreCard(this.$AuthUser.id, query)
        .then((response) => {
          this.averageScore = response.data.average;
          this.myScore = response.data.myScore ? response.data.myScore : "---";
          this.metaData = response.data.meta;

          const appraisals = response.data.sharedAppraisals;

          appraisals.forEach((appraisal) => {
            this.items.push({
              appraisee: `${appraisal.user.fname} ${appraisal.user.lname}`,
              designation: appraisal.user.designation,
              jobLevel: appraisal.user.level,
              functions: appraisal.user.function,
              appraisalScore: this.getAppraisalScore(appraisal.appraisals),
              appraisalDate: this.getAppraisalDate(appraisal.appraisals),
              photo: appraisal.user.photo,
              id: true,
            });
          });
          this.loadingTable = false;
        })
        .catch(() => {
          this.loadingTable = false;
        });
    },

    getAppraisalScore(appraisals) {
      let returnedData;
      const appraisalData = appraisals.find(
        (value) => value.cycleId === this.activeCycle
      );
      if (appraisalData) {
        if (appraisalData.reviewType === "mid_review") {
          returnedData = appraisalData.flag;
        } else {
          returnedData = appraisalData.approved_score;
        }
      }
      return returnedData || "---";
    },

    getAppraisalDate(appraisals) {
      let returnedData;
      const appraisalData = appraisals.find(
        (value) => value.cycleId === this.activeCycle
      );
      if (appraisalData) {
        returnedData = appraisalData.date_submitted;
      }
      return returnedData;
    },

    viewCycle(id) {
      this.activeCycle = id;
      this.loadingTable = true;
      this.getScoreCard();
    },
  },

  mounted() {
    this.getAppraisalCycle();
    this.getTemplate();
  },
};
</script>
